import Api from '../utils/api.service';
import ApiUrlConstant from '../utils/apiUrl.constant';
import Util from '../utils/util';
export default class OffersService {
    static getOffers(storeId, request) {
        let url = ApiUrlConstant.getApiUrl('offers', false);
        url = Util.beautifyUrl(url, [storeId]);
        return Api.doPost(url, request);
    }
}